import { NetworkStatus } from '@apollo/client';

export type UILoadingState = 'none' | 'initial' | 'secondary';

export function determineLoadingState({
  hasPreviousData,
  networkStatus,
}: {
  hasPreviousData: boolean;
  networkStatus: NetworkStatus;
}): UILoadingState {
  const secondaryLoadingStatuses = [
    NetworkStatus.refetch,
    NetworkStatus.setVariables,
    NetworkStatus.fetchMore,
  ];
  const secondaryLoading = secondaryLoadingStatuses.includes(networkStatus);

  const initialLoading =
    networkStatus === NetworkStatus.loading ||
    (secondaryLoading && !hasPreviousData); // if we are in a "no data" state.

  return initialLoading ? 'initial' : secondaryLoading ? 'secondary' : 'none';
}
